import React, { useState, useEffect, useRef } from 'react';
import { FaPlus, FaTimes, FaEllipsisH } from 'react-icons/fa';
import styles from "assets/scss/task_management.module.css";
import TaskCard from '../User/TaskCard';
import { Trans } from 'react-i18next';
import { LocalForm } from 'react-redux-form';
import { PayrollClient } from "services";
import { NotificationManager } from "react-notifications";
import { DatePicker } from 'components/common';
import { Droppable, Draggable } from 'react-beautiful-dnd';
import { Modal, ModalHeader, ModalBody, Button, Row, Col, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem, Input } from 'reactstrap';

function TaskBucket({
    bucket,
    userPermission,
    handleCheckboxChange,
    name,
    tasks,
    fetchLabels,
    setBuckets,
    showOptions,
    setShowOptions,
    buckets,
    fetchData,
    fetchEmployees,
    handleDeleteTask,
    onUpdate,
    onReassign,
    reAssignRequests,
    groups,
    activeTab,
    t 
}) {
    const [showAddTaskForm, setShowAddTaskForm] = useState(false);
    const [newTaskName, setNewTaskName] = useState("");
    const [newTaskDueDate, setNewTaskDueDate] = useState(null);
    const [selectedEmployees, setSelectedEmployees] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const [taskNameError, setTaskNameError] = useState(false);
    const [showRenameInput, setShowRenameInput] = useState(false);
    const [newBucketName, setNewBucketName] = useState(bucket.bucket_name);
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [completedTasks, setCompletedTasks] = useState([]);
    const [showCompletedTasks, setShowCompletedTasks] = useState(false);

    const client = PayrollClient();
    const dropdownRef = useRef(null);

    useEffect(() => {
        const completed = tasks.filter(task => task.progress === 'Completed');
        setCompletedTasks(completed);
    }, [tasks]);


    useEffect(() => {
        if (showRenameInput) {
            document.addEventListener('mousedown', handleClickOutside);
        } else {
            document.removeEventListener('mousedown', handleClickOutside);
        }

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showRenameInput]);

    const handleAddNewTaskClick = () => {
        setShowAddTaskForm(prevState => !prevState);
    };
    const taskLabel = [];

    const handleUpdateTask = (updatedTask) => {
        const updatedTasks = bucket?.planner_bucket?.map(t => t.id === updatedTask.id ? updatedTask : t);
        setBuckets(prevBuckets => {
            return prevBuckets.map(bucket => {
                if (bucket.bucket_name === name) {
                    return { ...bucket, tasks: updatedTasks };
                } else {
                    return bucket;
                }
            });
        });
    };

    const handleAddNewTask = () => {
        if (newTaskName.trim() !== "") {
            const new_task = addBucketTask();
            const updatedTasks = [...tasks, new_task];
            setBuckets(prevBuckets => {
                return prevBuckets.map(bucket => {
                    if (bucket.name === name) {
                        return { ...bucket, tasks: updatedTasks };
                    } else {
                        return bucket;
                    }
                });
            });
            setNewTaskName("");
            setNewTaskDueDate(null);
            setSelectedEmployees([]);
            setShowAddTaskForm(false);
            setTaskNameError(false);
        } else {
            setTaskNameError(true);
        }
    };

    const handleAssignButtonClick = () => {
        setShowDropdown(prevState => !prevState);
    };

    const handleClickOutside = (event) => {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
            setShowRenameInput(false);
        }
    };

    const handleEmployeeSelect = (employeeId) => {
        if (selectedEmployees.includes(employeeId)) {
            setSelectedEmployees(selectedEmployees.filter(id => id !== employeeId));
        } else {
            setSelectedEmployees([...selectedEmployees, employeeId]);
        }
    };


    const handleRemoveEmployee = (employeeId) => {
        setSelectedEmployees(selectedEmployees.filter(id => id !== employeeId));
    };

    const [searchKeyword, setSearchKeyword] = useState("");

    const trimmedName = bucket.bucket_name?.length > 30 ? `${bucket.bucket_name.substring(0, 30)}...` : bucket.bucket_name;

    const handleRenameBucket = () => {
        setShowRenameInput(true);
    };

    const handleDeleteBucket = () => {
        setShowConfirmationModal(true);
    };

    const toggleConfirmationModal = () => {
        setShowConfirmationModal(!showConfirmationModal);
    };

    const handleConfirmDeleteBucket = () => {
        try {
            if (bucket.id) {
                client.delete(`/planner-bucket-list/${bucket.id}`);
                setBuckets(prevBuckets => prevBuckets.filter(bucket => bucket.id !== bucket.id));
                setShowConfirmationModal(false);

                NotificationManager.success(t("Bucket deleted successfully"));

                fetchData();
            }
            else {
                NotificationManager.error(t("Bucket not available."));
            }

        } catch (error) {
            NotificationManager.error(t("Error deleting bucket"));
        }
        setShowConfirmationModal(false);
        fetchData();
    };

    const handleCancelDeleteBucket = () => {
        setShowConfirmationModal(false);
    };

    const handleUpdateBucketName = () => {
        setShowRenameInput(false);
    };

    const updatePlannerBucket = () => {
        try {

            client
                .put(`/planner-bucket-list/${bucket.id}`, { bucket_name: newBucketName })
                .then(({ data }) => {

                    NotificationManager.success(t("Bucket Updated successfully"));
                    fetchData();
                })
        } catch (err) {
            NotificationManager.error(t('Error while Updaing the bucket name'));
        }
        setShowRenameInput(false);
    };

    const addBucketTask = () => {
        try {

            client
                .post(`/bucket-task-management/${bucket.id}/create_manager_task`, { bucket_task_name: newTaskName, end_date: newTaskDueDate, employee: selectedEmployees, planner_bucket: bucket.id, task_label: taskLabel })
                .then(({ data }) => {

                    NotificationManager.success(t("Task Added successfully"));
                    fetchData();
                })
        } catch (err) {
            NotificationManager.error(t('Error while Adding the task'));
        }
    };


    const handleCompleteTask = (taskId) => {
        const task = tasks.find(task => task.id === taskId);
        const updatedTask = { ...task, progress: 'Completed' };
        handleUpdateTask(updatedTask);
    };

    const toggleCompletedTasksVisibility = () => {
        setShowCompletedTasks(!showCompletedTasks);
    };

    const handleRemoveCompletedTask = (taskId) => {
        setCompletedTasks(completedTasks?.filter(task => task.id !== taskId));
    };
    const incompleteTasks = tasks?.filter(task => task.progress !== "Completed");


    const handleCloseTaskCard = () => {
        setShowAddTaskForm(false);
    };

    return (
        <div className="mx-3">
            <div className="row mx-0" onMouseEnter={() => setShowOptions({...showOptions,id:bucket?.id})} onMouseLeave={() => setShowOptions({dropdown: false, id: showOptions.id === bucket?.id ? bucket?.id : ''})}>
                <div className="col mb-2 px-0">
                    <>
                        <span><Trans>{!showRenameInput && trimmedName}</Trans></span>
                        {showRenameInput && (
                            <div className="d-flex justify-content-between" ref={dropdownRef}>
                                <div className="">
                                    <Input
                                        className={styles.updateBucketName}
                                        type="text"
                                        value={newBucketName}
                                        onChange={(e) => setNewBucketName(e.target.value)}
                                    />
                                </div>
                                <div className="">
                                    <Button className='mr-0' color="primary" onClick={updatePlannerBucket}><Trans>Update</Trans></Button>
                                </div>
                            </div>
                        )}
                    </>
                </div>
                <div className="row">
                    <div className={styles.options} ref={dropdownRef}>
                    {!showRenameInput  && showOptions?.id === bucket?.id && !showOptions?.dropdown && (

                        <UncontrolledDropdown className="mr-2" direction="end" >
                            <DropdownToggle className='bg-white border-0 px-0 py-1 btn-link' color="link">
                                <div className="text-dark clickable">
                                    <FaEllipsisH />
                                </div>
                            </DropdownToggle>
                            <DropdownMenu className='p-0'>
                                <DropdownItem onClick={handleRenameBucket} >
                                    <Trans>Rename</Trans>
                                </DropdownItem>
                                <DropdownItem onClick={handleDeleteBucket}>
                                    <Trans>Delete</Trans>
                                </DropdownItem>
                            </DropdownMenu>
                        </UncontrolledDropdown>
                    )}

                    </div>
                </div>
                <Modal isOpen={showConfirmationModal} toggle={toggleConfirmationModal} className="modal-dialog-centered">
                    <ModalHeader toggle={toggleConfirmationModal}><Trans>Confirm Delete</Trans></ModalHeader>
                    <ModalBody>
                        <p><Trans>Are you sure you want to delete this bucket?</Trans></p>
                        <div className="d-flex justify-content-between">
                            <Button color='danger' onClick={handleConfirmDeleteBucket}><Trans>Delete</Trans></Button>
                            <Button color='secondary' onClick={handleCancelDeleteBucket}><Trans>Cancel</Trans></Button>
                        </div>
                    </ModalBody>
                </Modal>
            </div>
            <div className={styles.addTaskButtonContainer}>
                <div className={styles.addNewTaskButton} onClick={handleAddNewTaskClick}>
                    <FaPlus />
                    <span><Trans> Add Task</Trans></span>
                </div>
            </div>
            {showAddTaskForm && (
                <div className={styles.addTaskCard}>
                    <Button color='danger' className="float-right mb-1 p-1" onClick={handleCloseTaskCard}><i className='fa fa-trash'></i></Button>
                    <div className={styles.taskNameInput}>
                        <input
                            type="text"
                            value={newTaskName}
                            onChange={(e) => setNewTaskName(e.target.value)}
                            placeholder={t("Enter Task Name")}
                            required
                        />
                        {taskNameError && <p style={{ color: 'red' }}><Trans>Your task needs a name</Trans></p>}
                    </div>
                    <div className={styles.addTaskDetails}>
                        <div className={styles.dueDateInput} style={{ position: 'relative' }}>
                            <LocalForm>
                                <DatePicker
                                    onChange={(e) => setNewTaskDueDate(e)}
                                    type="date"
                                    model=".date"
                                    placeholderText={t("Select Due Date")}
                                    wrapperClassName={styles.datePickerWrapper}
                                />
                            </LocalForm>
                        </div>
                        {activeTab === 'teamTasks' && userPermission && (
                            <div className={styles.assignInput}>
                                {/* <div className={styles.assignButtonContainer}> */}
                                <Row>
                                    <Col md={6}>
                                        <button className={styles.assignButton} onClick={handleAssignButtonClick}><Trans>Assign</Trans></button>
                                        {showDropdown && (
                                            <div ref={dropdownRef} className={styles.dropdownContent}>
                                                <div>
                                                    <input
                                                        type="text"
                                                        placeholder={t("Search Employees")}
                                                        value={searchKeyword}
                                                        onChange={(e) => setSearchKeyword(e.target.value)}
                                                    />
                                                </div>
                                                {selectedEmployees?.length > 0 && (
                                                    <>
                                                        <div className={styles.assignedEmployees}><strong><Trans>Assigned</Trans></strong></div>
                                                        {selectedEmployees?.map(employeeId => (
                                                            <button key={employeeId} className={styles.assignedEmployee}>
                                                                {fetchEmployees?.find(employee => employee?.id === employeeId)?.full_name}
                                                                <FaTimes onClick={() => handleRemoveEmployee(employeeId)} />
                                                            </button>
                                                        ))}
                                                    </>
                                                )}
                                                <div className={styles.suggestions}><strong><Trans>Suggestions</Trans></strong></div>
                                                {fetchEmployees
                                                    .filter(employee => !selectedEmployees.includes(employee.id) && employee.full_name.toLowerCase().includes(searchKeyword.toLowerCase()))
                                                    .map((employee, index) => (
                                                        <button
                                                            key={index}
                                                            className={styles.suggestion}
                                                            onClick={() => {
                                                                handleEmployeeSelect(employee.id);
                                                                setSearchKeyword("");
                                                            }}
                                                        >
                                                            {employee.full_name}
                                                        </button>
                                                    ))}
                                            </div>
                                        )}
                                    </Col>
                                    {/* </div> */}

                                </Row>
                            </div>
                        )}
                    </div>
                    <Row className='mt-5'>
                        <Col md={12}>
                            <button className={styles.addTaskButton} onClick={handleAddNewTask}><Trans>Add Task</Trans></button>
                        </Col>
                    </Row>
                </div>
            )}


            <Droppable droppableId={bucket?.id?.toString()} type="TASK">
                {(provided) => (
                    <div ref={provided.innerRef} {...provided.droppableProps} className={styles.scrollTask}>
                        {incompleteTasks?.map((task, taskIndex) => (
                            <Draggable key={task?.id} draggableId={task?.id?.toString()} index={taskIndex}>
                                {(provided, snapshot) => (
                                    <div
                                        ref={provided.innerRef}
                                        {...provided.draggableProps}
                                        {...provided.dragHandleProps}
                                        className={`${styles.taskCard} ${snapshot.isDragging ? styles.dragging : ''}`}
                                    >
                                        <TaskCard
                                            key={task.id}
                                            task={task}
                                            onDelete={() => handleDeleteTask(task)}
                                            onUpdate={onUpdate}
                                            availableEmployees={fetchEmployees}
                                            onReassign={onReassign}
                                            reAssignRequests={reAssignRequests}
                                            fetchLabels={fetchLabels}
                                            groups={groups}
                                            buckets={buckets}
                                            userPermission={userPermission}
                                            activeTab={activeTab}
                                            onComplete={() => handleCompleteTask(task?.id)}
                                            t={t}
                                            handleCheckboxChange={handleCheckboxChange}
                                        />
                                    </div>
                                )}
                            </Draggable>
                        ))}
                        {provided.placeholder}
                    </div>
                )}
            </Droppable>

            {completedTasks?.length > 0 && (
                <div className={styles.completedTasksSection} onClick={toggleCompletedTasksVisibility}>
                    <button className="w-100 p-1 pe-auto bg-light h-50 mb-3 border border-white ">
                        <Trans>Completed Tasks</Trans>({completedTasks?.length}) <span className='bi bi-arrow-down'></span>
                    </button>
                    {showCompletedTasks && (
                        <Droppable droppableId={`${bucket?.id?.toString()}`} type="TASK">
                            {(provided) => (
                                <div ref={provided.innerRef} {...provided.droppableProps} className={styles.scrollTask}>
                                    {completedTasks?.map((task, taskIndex) => (
                                        <Draggable key={task?.id} draggableId={task?.id?.toString()} index={taskIndex}>
                                            {(provided) => (
                                                <div ref={provided.innerRef} {...provided.draggableProps} {...provided.dragHandleProps}>
                                                    <TaskCard
                                                        key={task.id}
                                                        task={task}
                                                        onDelete={() => handleRemoveCompletedTask(task?.id)}
                                                        onUpdate={onUpdate}
                                                        availableEmployees={fetchEmployees}
                                                        onReassign={onReassign}
                                                        reAssignRequests={reAssignRequests}
                                                        fetchLabels={fetchLabels}
                                                        groups={groups}
                                                        buckets={buckets}
                                                        userPermission={userPermission}
                                                        activeTab={activeTab}
                                                        isCompleted={true}
                                                        t={t}
                                                        handleCheckboxChange={handleCheckboxChange}
                                                    />
                                                </div>
                                            )}
                                        </Draggable>
                                    ))}
                                    {provided.placeholder}
                                </div>
                            )}
                        </Droppable>
                    )}
                </div>
            )}
        </div>
    );
}

export default TaskBucket;